export default {
  title: 'Decision Support Tools',
  description: 'Estimator24 helps buyers, investors, and agencies make informed decisions based on data and AI.',
  features: {
    evaluation: 'One-click property valuation',
    forecast: 'Price forecasts using neural networks',
    analytics: 'Market analysis by region and district',
    tools: 'Comparison and filtering tools'
  }
}
